import React from 'react';
import Bar from 'react-bootstrap/ProgressBar';
 
export default function ProgressBar(props) {
  return <Bar now={props.now} label={`${props.now}%`} />;
}
